import { ISalesDocumentTypeCode } from '../sales-document-management/models/sales-document-type-code';

export interface AdditionalServicesReq {
  shipmentLocationId: number;
  shippingConditionId: number;
  productLineId: number;
  salesDocumentTypeCode: ISalesDocumentTypeCode;
  salesAreaId: number;
}
